/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deletelistingwarning2Inputs */

const en_deletelistingwarning2 = /** @type {(inputs: Deletelistingwarning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone. This will permanently delete the listing.`)
};

const de_deletelistingwarning2 = /** @type {(inputs: Deletelistingwarning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das kann nicht rückgängig gemacht werden. Der Ort wird endgültig gelöscht.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone. This will permanently delete the listing." |
*
* @param {Deletelistingwarning2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const deletelistingwarning2 = /** @type {((inputs?: Deletelistingwarning2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deletelistingwarning2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deletelistingwarning2(inputs)
	return de_deletelistingwarning2(inputs)
});
export { deletelistingwarning2 as "deleteListingWarning" }